// extracted by mini-css-extract-plugin
export default {"info":"style_info__tcR1T","tooltip":"style_tooltip__z11hy"};